<div class="mep-dialog-header-icon">
	<mat-icon>file_upload</mat-icon>
</div>
<h2 class="mep-dialog-title">
	{{ _lang("upload-to-mephisto") }}
</h2>
<div class="mep-dialog-content" mat-dialog-content>
	@if (!isLoading) {
		<div>
			<mat-form-field class="w-100">
				<mat-label>{{ _lang("select-upload-type") }}</mat-label>
				<mat-select [(value)]="uploadType" (selectionchange)="removeErrorMessage()">
					<mat-option [value]="'pdf'">{{ _lang("upload-as-pdf") }}</mat-option>
					<mat-option [value]="'text'">{{ _lang("upload-as-text") }}</mat-option>
				</mat-select>
			</mat-form-field>
			@if (uploadType === "pdf") {
				<div>
					<app-file-drag-drop [(ngModel)]="selectedFile" (ngModelChange)="onFileChosen($event)" accept=".pdf">
					</app-file-drag-drop>
					@if (isInvalidFile) {
						<mat-error class="error-message">
							{{ _lang("only-pdf-files-allowed") }}
						</mat-error>
					}
				</div>
			}
			@if (uploadType === "text") {
				<div>
					<mat-form-field class="w-100">
						<mat-label>{{ _lang("paste-raw-text") }}</mat-label>
						<textarea
							class="raw-text-field"
							matInput
							[(ngModel)]="rawText"
							(ngModelChange)="removeErrorMessage()"
							cdkTextareaAutosize
						></textarea>
					</mat-form-field>
				</div>
			}
			@if (errorMessageShown) {
				<mat-error class="error-message">
					{{ errorMessageShown }}
				</mat-error>
			}
		</div>
	}

	@if (isLoading) {
		<div class="loader-container">
			<div class="loader">
				@if (!showDelayMessage) {
					<div>
						{{ _lang("waiting-for-mephisto") }}
					</div>
				}
				@if (showDelayMessage) {
					<div class="delay-message">
						{{ _lang("this-may-take-a-while") }}
					</div>
				}
			</div>
			<mat-progress-spinner class="mep-progress-spinner" [diameter]="40" mode="indeterminate"> </mat-progress-spinner>
		</div>
	}
</div>
<div class="mep-dialog-actions">
	<button (click)="closeDialog()" class="mep-btn-dialog-secondary">{{ _lang("cancel") }}</button>
	<button (click)="uploadData()" class="mep-btn-dialog-primary" [disabled]="isUploadDisabled() || isLoading">
		{{ _lang("upload") }}
	</button>
</div>
